<template>
    <div class="ex-box">
        <div class="ex-list">
            <div class="ex-no">物流公司: {{express.express_name}}</div>
            <div class="ex-no">物流单号: {{express.express_no}}</div>
        </div>
        <div class="logis-detail">
            <div class="logis-detail m-top20 b-f" v-if="express.list">
                <div :class="['logis-item', index ==0 ? 'first' : '']" v-for="(item,index) in express.list"
                     :key="index">
                    <div class="logis-item-content">
                        <div class="logis-item-content__describe">
                            <span class="f-26">{{ item.context }}</span>
                        </div>
                        <div class="logis-item-content__time">
                            <span class="f-22">{{ item.ftime }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="noresult" style="padding-bottom: 70px" v-if="!express.list">
                <div class="cot">
                    <div class="img">
                        <img src="../../assets/images/no_result.png">
                    </div>
                    <p class="text" style="color: #666;">暂无物流信息</p>
                </div>
            </div>
        </div>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
export default {
    name: 'OrderExpress',
    data() { //默认数据
        return {
            options: {},
            express: {},
            // show
            noresult: false,
            order_id: 0,
        }
    },
    created() { //视图加载前执行
        let _this = this;
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });
        _this.order_id = _this.$route.query.order_id;
    },
    mounted() { //视图加载完成执行
        let _this = this;
        _this.getExpressList(_this.$route.query.order_id);
    },
    methods: { //页面方法

        // 查询物流列表
        getExpressList(order_id) {
            let _this = this
            _this._get('user.order/express', {
                order_id
            }, res => {
                _this.express = res.data.express;
                _this.loading.hide();
            }, () => {
                _this.$router.go(-1);
            });
        },

    }
}
</script>
<style lang="scss">
@import "express.scss";
</style>
